export const knowledgeBaseConstants = {
    KNOWLEDGE_BASE_SUCCESS: 'KNOWLEDGE_BASE_SUCCESS',
    KNOWLEDGE_BASE_REQUEST: 'KNOWLEDGE_BASE_REQUEST',
    KNOWLEDGE_BASE_FAILURE: 'KNOWLEDGE_BASE_FAILURE',
};

export const KnowledgeBaseType = {
    FAQ: 1,
    DOCUMENT: 2,
    WEBSITE: 3,
};

export const KnowledgeDocumentStatus = {
    PROCESSING: 1,
    READY: 2,
    FAILED: 3,
};

export const KNOWLEDGE_BASE_TYPE_LABELS = {
    [KnowledgeBaseType.FAQ]: 'KnowledgeBase.faq',
    [KnowledgeBaseType.DOCUMENT]: 'KnowledgeBase.document',
    [KnowledgeBaseType.WEBSITE]: 'KnowledgeBase.website',
};

export const KNOWLEDGE_BASE_LIMIT_TOOLTIPS = {
    [KnowledgeBaseType.DOCUMENT]: 'KnowledgeBase.documentsAtLimit',
    [KnowledgeBaseType.WEBSITE]: 'KnowledgeBase.websitesAtLimit',
};
